<template>
    <v-card>
        <!-- Toolbar -->
        <v-toolbar
            dark
            color="primary"
        >
            <v-btn
                icon
                dark
                @click="$emit('update:show', false)"
                :disabled="isSaving"
            >
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>
                Edit Photo
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items
                v-if="$vuetify.breakpoint.smAndDown"
            >
                <!-- Save Button -->
                <v-btn
                    dark
                    text
                    :loading="isSaving"
                    :disabled="isSaving"
                    @click="onSubmit"
                >
                    Save
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <!-- Form -->
        <v-card-text>
            <v-form
                class="my-3"
                ref="form"
                @submit.prevent="onSubmit"
            >
                <v-file-input
                    label="Photo (Max: 100kB)"
                    accept="image/*"
                    v-model="file"
                    show-size
                    clearable
                    :rules="[
                        rules.required,
                        rules.fileSize
                    ]"
                    counter
                    @change="onFileChange"
                />
            </v-form>
            <div class="d-flex justify-center">
                <v-avatar size="150">
                    <v-img
                        :src="preview"
                        width="150"
                    />
                </v-avatar>
            </div>
        </v-card-text>
        <v-card-actions
            v-if="$vuetify.breakpoint.mdAndUp"
        >
            <v-spacer />
            <v-btn
                text
                @click="$emit('update:show', false)"
            >
                Cancel
            </v-btn>
            <v-btn
                @click="onSubmit"
                color="primary"
                :loading="isSaving"
                :disabled="isSaving"
            >
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from 'axios'
import { requiredValidation } from '../../utils/validations'
import MessageBus from '../../utils/buses/MessageBus'
import { default422Error } from '../../utils/constants/errors'
import { axiosPublic } from '../../plugins/axios'
import UserBus from '../../utils/buses/UserBus'

const NO_PREVIEW_AVAILABLE = require('../../assets/no_preview_available.jpg')

export default {
    data () {
        const reader = new FileReader()
        reader.onload = e => {
            this.preview = e.target.result
        }

        return {
            file: null,
            rules: {
                required: requiredValidation,
                fileSize: val => (val && val.size <= 100000) || 'File must be 100kB or less'
            },
            preview: NO_PREVIEW_AVAILABLE,
            reader
        }
    },

    props: {
        show: {
            type: Boolean,
            required: true
        },
        isSaving: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onFileChange (file) {
            if (file) {
                this.reader.readAsDataURL(file)
            } else {
                // if file is cleared, set preview back to default
                this.preview = NO_PREVIEW_AVAILABLE
            }
        },
        async onSubmit () {
            if (!this.$refs.form.validate()) {
                MessageBus(default422Error, 'error')
                return
            }

            this.$emit('update:isSaving', true)

            try {
                const res = await axios.put('/upload-photo', {
                    name: this.file.name,
                    contentType: this.file.type
                })

                const postData = res.data.postData
                const url = postData.url
                const formData = new FormData()
                Object.keys(postData.fields).forEach(key => {
                    const value = postData.fields[key]
                    formData.append(key, value)
                })

                // file must be appended last
                formData.append('file', this.file)

                // s3 post object does not return anything on success
                await axiosPublic.post(
                    url,
                    formData
                )

                this.$emit('update:show', false)

                // emit new user image url to parent
                this.$emit('save', res.data.userImage)
                MessageBus.sendMessage('Photo uploaded succesfully', 'success')
                // update token
                UserBus.setToken(res.data.token)
            } catch (err) {
                console.error('Error uploading photo', err)
                MessageBus.sendMessage('Error uploading photo', 'error')
            } finally {
                this.$emit('update:isSaving', false)
            }
        }
    }
}
</script>
